import { Flex, Text } from '@chakra-ui/react';
import { FormFeedback, OutlineCard, TextArea } from '@morressier/alembic';
import { useFormContext } from 'react-hook-form';
import { FieldLabel } from 'src/components/Field';
import { ISubmissionFormData } from 'src/contexts/FormContext';
import { FormFieldEthicsStatement } from '@publishing-engine/domain/types/article';
import { RadioGroup } from 'src/components/RadioGroup';
import { get } from 'lodash';
import { useSubmissionContextData } from 'src/contexts/SubmissionContextProvider';
import { getValidationTypedMessage } from '../../../../../../components/FormField/common/errorMessages';

const EthicsStatement = ({ config }: { config: FormFieldEthicsStatement }) => {
  const {
    formState: { errors },
    register,
    watch,
    control
  } = useFormContext<ISubmissionFormData>();
  const {
    params: { validations, labels },
    caseDataFields: { main: field, dependsOn }
  } = config;
  const dependsOnField = `${field}.${dependsOn}` as const;
  const mainField = `${field}.value` as const;

  const error = get(errors, field);

  const exists = watch(dependsOnField);
  const ethicsStatement = watch(mainField);

  const { submissionContext } = useSubmissionContextData();
  const submissionPreferences =
    submissionContext?.config.cms.authorSubmissionForm.submissionPreferences;

  if (!submissionPreferences) return <h1>missing form Information</h1>;

  return (
    <Flex flexDirection="column" gap={8}>
      <Flex flexDirection="column" gap={2}>
        <Text textStyle="headingSection">
          {submissionPreferences.ethics.mainLabel}
        </Text>
        <Text textStyle="textBody">
          {submissionPreferences.ethics.secondaryLabel}
        </Text>
      </Flex>

      <OutlineCard padding={8} borderless>
        <Flex flexDirection="column" gap={4}>
          <FieldLabel
            isRequired={validations.required}
            label={labels.main}
            subText={labels.subtitle}
          />

          <RadioGroup
            name={dependsOnField}
            control={control}
            options={[
              {
                value: false,
                children: labels.options['false']?.main
              },
              {
                value: true,
                children: labels.options['true']?.main
              }
            ]}
          />
          {error?.[dependsOn] ? (
            <FormFeedback variant="error">
              Please indicate whether your submission includes ethics statement
              to proceed
            </FormFeedback>
          ) : null}
        </Flex>
      </OutlineCard>

      {exists ? (
        <OutlineCard padding={8} borderless>
          <Flex flexDirection="column" gap={4}>
            <FieldLabel
              label={labels.section.title}
              // [COMA-1433] - This text should be rendered via configuration, since is an IOPP specific block
              subText={labels.section.explanation}
              isRequired
            />
            <TextArea
              placeholder="Ethics statement"
              value={ethicsStatement || ''}
              isInvalid={Boolean(error?.value)}
              errorMessage={
                error?.value &&
                getValidationTypedMessage(
                  labels.main,
                  validations.kind,
                  validations,
                  error.value
                )
              }
              characterLimit={validations.maxLength}
              {...register(mainField)}
              isRequired={validations.required}
            />
          </Flex>
        </OutlineCard>
      ) : null}
    </Flex>
  );
};

export default EthicsStatement;
